/* eslint-disable */
module.exports = {
BASE_DASHBOARD_URL: 'https://web.triauto.invast.jp/',
REST_API_URL: 'https://prd.api.ta23.invast.jp/',
WS_API_URL: 'https://prd.ws.ta23.invast.jp/socket/',
MARKUPS_URL: 'https://www.invast.jp/triauto/rules/#fx-fee',
FA_JS_LOGIN: 'https://static.fraud-alert.net/Caulis.invast_triauto.min.js',
FA_JS_HOME: 'https://static.fraud-alert.net/Caulis.invast_success_triauto.min.js',
FA_ENABLED: 'true',
IMS_LOGINPAGE_URL: '',
AMPLIFY_AUTH_USER_POOL_ID: 'ap-northeast-1_1WafKtVYm',
AMPLIFY_AUTH_USER_POOL_WEB_CLIENT_ID: '554a450h1200adjoq50gd9veo8',
MY_PAGE_HOME_URL: 'https://mypage.invast.jp/portal/home/',
AGREEMENT_URL: 'https://mypage.invast.jp/cd/tool/triauto/index.html',
BUGSNAG_MOBILE_RELEASE_STAGE: 'Production',
BUGSNAG_WEB_RELEASE_STAGE: 'Production',
MOBILE_COMMON_PREFIX_URL: 'https://web.triauto.invast.jp/mobile',
MOBILE_CHART_URL: 'https://web.triauto.invast.jp/mobile-chart',
MY_PAGE_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-my-page',
INVAST_AFFILIATE_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-invast-affiliate',
PAYMENT_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-payment',
PAYMENT_DEPOSIT_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-payment-deposit',
PAYMENT_TRANSFER_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-payment-transfer',
PAYMENT_WITHDRAWAL_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-payment-withdrawal',
PAYMENT_DETAIL_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-payment-detail',
QUICK_DEPOSIT_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-quick-deposit',
QUICK_DEPOSIT_SUCCESS_URL: 'https://web.triauto.invast.jp/cash-deposit-success',
QUICK_DEPOSIT_FAILED_URL: 'https://web.triauto.invast.jp/cash-deposit-failed',
MONEY_HATCH_REDIRECT_URL: 'https://web.triauto.invast.jp/sso-money-hatch',
MOBILE_BUILDER_CHART_URL: 'https://web.triauto.invast.jp/builder-chart',
MOBILE_TECH_BUILDER_CHART_URL: 'https://web.triauto.invast.jp/mobile/tech-builder-chart',
MOBILE_AUTO_SELECT_PRICE_CHART_URL: 'https://web.triauto.invast.jp/mobile/auto-select-price-chart',
OTHER_WINDOW_AUTO_SELECT_DETAIL_CHART_URL: 'https://web.triauto.invast.jp/other-window-auto-select-detail-chart',
MOBILE_MARKET_ORDER_CHART_URL: 'https://web.triauto.invast.jp/mobile/market-order-chart',
MOBILE_LAB_PRICE_CHART_URL: 'https://web.triauto.invast.jp/mobile/lab-price-chart',
URL_SSO_DEPOSIT_RT: 'URL_SSO_DEPOSIT_RT',
URL_SSO_PAYMENT_DEPOSIT: 'URL_SSO_PAYMENT_DEPOSIT',
URL_SSO_TRANSFER_WITHDRAWAL: 'URL_SSO_TRANSFER_WITHDRAWAL',
URL_SSO_WITHDRAWAL: 'URL_SSO_WITHDRAWAL',
URL_SSO_PAYMENT_HISTORY: 'URL_SSO_PAYMENT_HISTORY',
URL_SSO_PAYMENT_VIRTUAL: 'URL_SSO_PAYMENT_VIRTUAL',
FORGOT_EMERGENCY_ID_URL: 'https://mypage.invast.jp/portal/confirm/id',
PASSKEY_DETAIL_URL: 'https://www.invast.jp/security/passkey/',
PASSKEY_LOGIN_ISSUE_URL: 'https://www.invast.jp/blogs/faqs/%E3%83%91%E3%82%B9%E3%82%AD%E3%83%BC%E8%AA%8D%E8%A8%BC/passkey-login/',
OTP_LOGIN_ISSUE_URL: 'https://www.invast.jp/blogs/account/etc/0628',
TWITTER_URL: 'https://www.twitter.com/triauto_invast',
FACEBOOK_URL: 'https://ja-jp.facebook.com/invastsecurities',
YOUTUBE_URL: 'https://www.youtube.com/user/INVASTSecurities',
LINE_URL: 'https://line.me/R/ti/p/@816mszlr',
MAINTENANCE_PAGE_URL: 'https://www.invast.jp/maintenance/info/',
MOBILE_FORGET_PASSWORD_URL: 'https://mypage.invast.jp/portal/login/',
MY_PAGE_BASE_URL: 'https://mypage.invast.jp',
LAB_POST_CONDITION_LINK: 'https://www.invast.jp/triauto/blogs/builders_share',
MAINTENANCE_INFOPAGE_URL: 'https://www.invast.jp/maintenance/',
AMPLIFY_AUTH_REGION: 'ap-northeast-1',
AMPLIFY_AUTH_AUTHENTICATION_FLOW_TYPE: 'CUSTOM_WITHOUT_SRP',
BUGSNAG_WEB_API_KEY: '93e008b261549b4dc1948372579b4083',
BUGSNAG_MOBILE_API_KEY: '9119b6e35f440f9a2eca219994b52fd8',
DEBUG: 'false',
MANUAL_PC_LINK: 'https://info.invast.jp/triauto-manual-pc',
MANUAL_SP_LINK: 'https://info.invast.jp/triauto-manual-sp',
MANUAL_FX_LINK: 'https://www.invast.jp/blogs/tafx/manual/',
MANUAL_ETF_LINK: 'https://www.invast.jp/blogs/etf/manual/',
MANUAL_FX_SP_LINK: 'https://www.invast.jp/blogs/tafx/manual_sp/',
MANUAL_ETF_SP_LINK: 'https://www.invast.jp/blogs/etf/manual_sp/',
BLOG_LINK: 'https://www.invast.jp/triauto/blogs/',
FAQ_LINK: 'https://www.invast.jp/triauto/blogs/faqs/',
INQUIRY_LINK: 'https://www.invast.jp/support/contact/',
NOTICE_LINK: 'https://www.invast.jp/news/list.php',
INVAST_HOME_LINK: 'https://www.invast.jp/',
FX_SWAP_SUMMARY_LINK: 'https://www.invast.jp/triauto/swap-calendar/',
CFD_INTEREST_RATE_TABLE_LINK: 'https://www.invast.jp/cfd/interest-calendar/',
BUILDER_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/builder-multi/',
CHART_MAKE_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/chartmake/',
TECHNICAL_BUILDER_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/technicalbuilder/',
IOS_STORE_LINK: 'https://apps.apple.com/jp/app/toraiotofx/id6467229971',
BUILDER_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/builder-multi/',
CHART_MAKE_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/chartmake/',
TECHNICAL_BUILDER_EXPLANATION_LINK: 'https://www.invast.jp/triauto/blogs/technicalbuilder/',
ANDROID_STORE_LINK: 'https://play.google.com/store/apps/details?id=com.invast.triauto23.android.tradechannel',
QUICK_DEPOSIT_INFO_FX_LINK: 'https://www.invast.jp/triauto/rules/#fx-instant_deposit',
QUICK_DEPOSIT_INFO_ETF_LINK: 'https://www.invast.jp/triauto/rules/#etf-instant_deposit',
QUICK_DEPOSIT_INFO_CFD_LINK: 'https://www.invast.jp/triauto/rules/#cfd-instant_deposit',
OMAKASE_PLAN_DESCRIPTION_LINK: 'https://www.invast.jp/triauto/blogs/auto-select/',
TRADE_AP_DESCRIPTION_LINK: 'https://www.invast.jp/triauto/blogs/trading-automation/',
STAGE: 'PRODUCTION',
};
